/** Aviso sobre Pix / banco / suporte no Discord — landing, planos e perfil. */
export const VIP_PIX_DISCORD_NOTICE =
    'Caso seu banco esteja autorizando o Pix, abrir ticket no Discord - e caso não tenha Pix, ticket também.';
